module.exports = __webpack_public_path__ + "static/img/SEPA.193f508.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/static/images/logo/SEPA.png
// module id = 1478
// module chunks = 2